// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3UHt-","inputWrap":"Table_inputWrap__1HWl4","col":"Table_col__1Z_Cr","bmiTooltip":"Table_bmiTooltip__XDet3"};